import { Practitioner } from "./../../open-age/telepain/models/practitioner";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UxService } from "~/app/core/services/ux.service";
import { RoleService } from "~/app/open-age/core/services";
import { NavService } from "~/app/core/services";
import { ActivatedRoute } from "@angular/router";
import { Link } from "~/app/open-age/core/structures";
import { MatDialog } from "@angular/material";
import { AddPatientsDialogComponent } from "../components/add-patients-dialog/add-patients-dialog.component";
import { Patient } from "./../../open-age/telepain/models/patient";
import { Appointment } from '~/app/open-age/welcome/models/appointment.model';
import * as moment from 'moment-timezone';
import { User } from '~/app/open-age/welcome/models/user.model';
import { AppointmentsService, AvailabilityService } from '~/app/open-age/welcome/services';
import { QuickAddPatientsDialogComponent } from '../components/quick-add-patients-dialog/quick-add-patients-dialog.component';
import { AvailableDate, AvailableTime } from "~/app/open-age/welcome/models/appointment-type.model";

@Component({
  selector: "app-appointment",
  templateUrl: "./appointment.component.html",
  styleUrls: ["./appointment.component.css"],
})
export class AppointmentComponent implements OnInit {
  id: string;
  appointment: Appointment = new Appointment({});
  isProcessing: boolean;
  isTimeProcessing: boolean;
  displayedColumns: string[] = [
    "name",
    "practice",
    "location",
    "prescriber",
    "action",
  ];
  isCurrent = true;
  page: Link;
  showSearchContainer: boolean = false;
  date: Date
  availableDates: AvailableDate[] = []
  selectedDate: AvailableDate
  availableTimes: AvailableTime[] = []
  selectedTime: AvailableTime
  availableSlots = 0

  @ViewChild("userInput")
  patientInput: ElementRef<HTMLInputElement>;

  @ViewChild("table") table;
  userInput: ElementRef<HTMLInputElement>;

  startTime: string;
  endTime: string;

  timeZones = ["Asia/Calcutta", "America/Los_Angeles"]
  timeZone: string

  constructor(
    public dialog: MatDialog,
    private auth: RoleService,
    private errorHandler: UxService,
    private navService: NavService,
    private route: ActivatedRoute,
    private appointmentService: AppointmentsService,
    private availabilityService: AvailabilityService
  ) {
    let exist = false
    for (const item of this.timeZones) {
      if (item == moment.tz.guess()) {
        exist = true
        this.timeZone = item
      }
    }
    if (!exist) {
      this.timeZones.push(moment.tz.guess())
      this.timeZone = this.timeZones[this.timeZones.length - 1]
    }
    this.page = this.navService.register(
      `/appointment/list/:id`,
      this.route,
      (isCurrent, params) => {
        this.isCurrent = isCurrent;
        if (this.isCurrent) {
          this.setContext();
        }
        if (params.get("id")) {
          this.id = params.get("id")
        }
      }
    );
  }

  ngOnInit() {
    this.isProcessing = true
    this.appointmentService.get(this.id).subscribe(item => {
      this.appointment = new Appointment(item)
      this.date = moment(moment(this.appointment.from.toString()).tz(this.timeZone).format("YYYY-MM-DD"), "YYYY-MM-DD").toDate()
      this.checkTimeSlot()
      this.getDates()
    })
  }

  checkTimeSlot() {
    this.isTimeProcessing = true
    this.availabilityService.slots.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      date: moment(this.date.toString()).format("YYYY-MM-DD"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      this.availableTimes = []
      for (const item of page.items) {
        let slot = new AvailableTime(item, this.timeZone)
        if (moment(item.time).tz(this.timeZone).format("hh:mm a") == moment(this.appointment.from.toString()).tz(this.timeZone).format("hh:mm a")) {
          this.selectedTime = slot
          this.availableSlots = item.slotsAvailable
        }
        this.availableTimes.push(slot)
      }
      this.isTimeProcessing = false
    })
  }

  add() {
    if (this.availableSlots < 0) {
      this.errorHandler.handleError(`Please remove ${Math.abs(this.availableSlots)} patinets. Slots Exausted!`);
      return;
    }
    if (!this.appointment.appointmentType) {
      this.errorHandler.handleError("Appointment Topic is required");
      return;
    }
    this.appointment.from = this.selectedTime.time
    if (!this.appointment.from) {
      this.errorHandler.handleError("Appointment Date is required");
      return;
    }
    if (!this.appointment.visitors || !this.appointment.visitors.length) {
      this.errorHandler.handleError("Patients are required in Appointment");
      return;
    }
    this.isProcessing = true
    this.appointmentService.update(this.appointment.id, this.appointment).subscribe(() => {
      this.errorHandler.showInfo("Appointment Updated Succesfully");
      this.isProcessing = false
      this.back()
    }, err => {
      this.isProcessing = false
    })
  }

  setContext() { }

  back() {
    this.navService.goto("/appointment/list");
  }

  setClass() {
    return (date: any) => {
      if (date) {
        date = moment(date).toDate()
        if (date.getDate() == 1) this.changeMonth(
          {
            month: date.getMonth() + 1,
            year: date.getFullYear()
          });
      }
    };
  }

  changeMonth(date) {
    console.log(date)
  }

  onDateUpdate($event) {
    this.selectedTime = null
    this.availableTimes = []
    this.date = $event.value
    this.availableSlots = 0
    this.availabilityService.slots.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      date: moment($event.value).format("YYYY-MM-DD"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      this.availableTimes = []
      for (const item of page.items) {
        this.availableTimes.push(new AvailableTime(item, this.timeZone))
      }
      if (this.availableTimes.length == 0) {
        this.errorHandler.handleError("Not timeslot found for select Date and Appointment")
      }
    })
  }

  displayPrescriber(item?: Practitioner): string | undefined {
    if (!item) {
      return "";
    }

    if (typeof item === "string") {
      return item;
    }

    if (!item.profile) {
      return item.code;
    }
    return `${item.prefix} ${item.profile.firstName} ${item.profile.lastName}`;
  }

  onBulkAdd(): void {
    const dialogRef = this.dialog.open(AddPatientsDialogComponent);
    if (this.appointment.visitors) {
      let patients: Patient[] = []
      this.appointment.visitors.forEach(item => {
        let newPatient = new Patient(item.user)
        newPatient.practiceLocation = item.user.meta.division
        // newPatient.practitioner = item.user.meta.prescriber
        newPatient.practice = item.user.meta.organization
        patients.push(newPatient)
      })
      dialogRef.componentInstance.patients = patients
      dialogRef.componentInstance.availableSlots = this.availableSlots + patients.length
    }
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.isSuccess) {
        this.appointment.visitors = []
        if (data.patients && data.patients.length) {
          data.patients.forEach(patient => {
            let meta = {
              division: patient.practiceLocation,
              providers: patient.practitioners,
              organization: patient.practice
            }
            let newUser = new User({
              role: patient.role,
              profile: patient.profile,
              meta: meta
            })
            if (patient.profile && patient.profile.middleName) {
              newUser.profile.lastName = patient.profile.middleName + " " + newUser.profile.lastName
            }
            if (patient.profile && patient.profile.prefix) {
              newUser.profile.title = patient.profile.prefix
            }
            this.appointment.visitors.push({ user: newUser })
            this.availableSlots--
          });
        }
      }
    });
  }

  quickAddUser() {
    const dialogRef = this.dialog.open(QuickAddPatientsDialogComponent);
    dialogRef.afterClosed().subscribe((data) => {
      if (data && data.isSuccess) {
        if (data.patient) {
          let visitors = []
          for (const visitor of this.appointment.visitors) {
            visitors.push(visitor)
          }
          this.appointment.visitors = []
          let exists = false
          for (const visitor of visitors) {
            if (visitor.user.role.id == data.patient.role.id) {
              exists = true
            }
          }
          if (!exists) {
            let meta = {
              division: data.patient.practiceLocation,
              providers: data.patient.practitioners,
              organization: data.patient.practice
            }
            let newUser = new User({
              role: data.patient.role,
              profile: data.patient.profile,
              meta: meta
            })
            if (data.patient.profile && data.patient.profile.middleName) {
              newUser.profile.lastName = data.patient.profile.middleName + " " + newUser.profile.lastName
            }
            if (data.patient.profile && data.patient.profile.prefix) {
              newUser.profile.title = data.patient.profile.prefix
            }
            visitors.push({ user: newUser })
            this.availableSlots--
          }
          this.appointment.visitors = visitors
        }
      }
    });
  }

  removePatient(patient: any) {
    let arr = []
    for (const visitor of this.appointment.visitors) {
      if (visitor.user.role.id != patient.user.role.id) {
        arr.push(visitor)
      }
    }
    this.appointment.visitors = arr;
    this.availableSlots++
  }

  onSelectedTime($event) {
    this.availableSlots = this.selectedTime.slotsAvailable - this.appointment.visitors.length
    this.appointment.from = this.selectedTime.time
  }

  reset() {
    this.date = moment(moment(this.appointment.from.toString()).tz(this.timeZone).format("YYYY-MM-DD"), "YYYY-MM-DD").toDate()
    this.selectedTime = null
    this.availableTimes = []
    this.availableSlots = 0
    this.availableDates = null
    this.getDates()
    this.checkTimeSlot()
  }

  getDates() {
    this.isProcessing = true
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
      this.isProcessing = false
    }, err => {
      this.isProcessing = false
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(1, 'month').format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(2, 'month').format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(3, 'month').format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(4, 'month').format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(5, 'month').format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
    this.availabilityService.dates.search({
      appointmentTypeID: this.appointment.appointmentType.acuityId,
      month: moment().add(6, 'month').format("YYYY-MM"),
      calendarID: this.appointment.calendar.acuityId,
      timeZone: this.timeZone
    }).subscribe(page => {
      if (!this.availableDates) {
        this.availableDates = []
      }
      for (const item of page.items) {
        this.availableDates.push(new AvailableDate(item))
      }
    })
  }

  timeZoneChange() {
    this.date = moment(moment(this.appointment.from.toString()).tz(this.timeZone).format("YYYY-MM-DD"), "YYYY-MM-DD").toDate()
    this.selectedTime = null
    this.availableTimes = []
    this.availableSlots = 0
    this.availableDates = null
    this.getDates()
    this.checkTimeSlot()
  }

  dateFilter(d: Date) {
    if (this.availableDates) {
      let found = false
      for (const availableDate of this.availableDates) {
        if (availableDate.date == moment(d).format('YYYY-MM-DD')) {
          found = true
        }
      }
      return found
    } else {
      return true
    }
  };

}
